import React from "react";
import { withRouter } from "react-router-dom";

class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (
      this.props.location.pathname !== prevProps.location.pathname
    ) {
      const elementId = this.props.location.hash;
      if(elementId) {
        setTimeout(() => {
          const element = document.querySelector(elementId);
          element.scrollIntoView({ behavior: 'smooth' });
        }, 500);
      } else {
        window.scroll(0,0)
      }
    }
  }

  render() {
    return null;
  }
}

export default withRouter(ScrollToTop);